module.exports = __webpack_public_path__ + "static/media/top_bottom_cover.e579928d.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/portfolio/assets/top_bottom_cover.png
// module id = 2253
// module chunks = 2